<template>
    <div class="HomePageStyle">
        <div class="collect_box">
            <div style="width:900px;margin:0px auto 30px;">
                <!-- <h2 style="font-size:20px; color:#333;">馆藏资源检索</h2> -->
                <h2 style="font-size:20px; color:#333;">馆藏资源查看</h2>

            </div>
            <el-row>
                <div v-if="!searchCompleted">
                    <el-col :span="10" :push="2" class="form_left">
                        <el-form :model="form" label-width="130px" :rules="rules" ref="formName">
                            <!-- <el-form-item label="选择图书馆：" prop="orgGid">
                                <el-select v-model="form.orgGid" filterable :filter-method="getOrgList"
                                    class="org-select">
                                    <el-option v-for="item in orgList" :key="item.gid" :label="item.orgName"
                                        :value="item.gid"></el-option>
                                </el-select>
                            </el-form-item> -->
                            <el-form-item label="检索关键词：" class="search" prop="cisbn">
                                <el-input v-model="form.cisbn" placeholder="请输入检索关键词"></el-input>
                            </el-form-item>
                            <el-form-item label="">
                                <div style="padding-top: 20px;">
                                    <el-button type="primary" @click="btnSubmit('formName')">检索</el-button>
                                    <el-button @click="resetForm('formName')" style="margin-left: 20px;">重置</el-button>
                                </div>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span="8" :offset="4">
                        <div class="tips_s">
                            <p class="tit"><i></i> <span>温馨提醒</span></p>
                            <div>
                                <p> 1、图书馆数据来源于公共组件-图书馆；</p>
                                <p> 2、支持按书名、作者、出版社等关键词检索；</p>
                                <p> 3、检索结果将展示资源的基本信息。</p>
                            </div>
                        </div>
                    </el-col>
                </div>
                <div v-else>
                    <el-col :span="22" :push="1">
                        <div class="search-result">
                            <div class="result-header">
                                <h3>检索结果（共 {{totalItems}} 条）</h3>
                                <el-button type="text" @click="backToSearch">返回检索</el-button>
                            </div>
                            <el-table :data="searchResults" style="width: 100%" border v-loading="tableLoading">
                                <el-table-column prop="cISBN" label="ISBN" width="300"></el-table-column>
                                <el-table-column prop="author" label="作者" width="150"></el-table-column>
                                <el-table-column prop="publisher" label="出版社" width="150"></el-table-column>
                                <el-table-column prop="publishDate" label="出版日期" width="100"></el-table-column>
                                <el-table-column prop="resourceType" label="资源类型" width="100">
                                    <template slot-scope="scope">
                                        <el-tag :type="getTagType(scope.row.resourceType)">{{scope.row.resourceType}}</el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="callNumber" label="索书号" width="120"></el-table-column>
                            </el-table>
                            <div class="pagination-container">
                                <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="currentPage"
                                    :page-sizes="[10, 20, 50, 100]"
                                    :page-size="pageSize"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="totalItems">
                                </el-pagination>
                            </div>
                        </div>
                    </el-col>
                </div>
            </el-row>
        </div>
    </div>
</template>

<script>
    import { Loading, Message } from 'element-ui'
    import { orgactionsearch, collectionretrieval } from '@/api/authority'

    export default {
        data() {
            return {
                form: {
                    cisbn: '',
                    orgGid: ''
                },
                orgList: [],
                rules: {
                    orgGid: [
                        { required: true, message: '请选择图书馆！', trigger: 'change' }
                    ],
                    cisbn: [
                        { required: true, message: '请输入检索关键词！', trigger: 'blur' }
                    ]
                },
                searchCompleted: false,
                searchResults: [],
                currentPage: 1,
                pageSize: 10,
                totalItems: 0,
                loading: null,
                tableLoading: false,
                headers: {}
            }
        },
        created() {
            let vm = this;
            let user = JSON.parse(localStorage.getItem('user'));
            if (user) {
                vm.headers = {
                    userId: user.userId,
                    token: user.token
                };
            }
        },
        mounted() {
            let vm = this;
            // vm.getOrgList()
        },
        methods: {
            // getOrgList(orgName) {//机构列表获取
            //     let vm = this;
            //     return new Promise(resolve => {
            //         const param = {
            //             orgType: 1,
            //             orgName: orgName,
            //             pageSize: 10,
            //             pageNum: 1,
            //         }
            //         orgactionsearch(param).then(res => {
            //             if (res.code == '200') {
            //                 let r = res.data.list;
            //                 vm.orgList = r;
            //             }
            //             resolve()
            //         })
            //     });
            // },
            btnSubmit(name) {
                let vm = this;
                vm.$refs[name].validate((valid) => {
                    if (valid) {
                        vm.searchLibrary();
                    } else {
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            // 检索馆藏
            searchLibrary() {
                let vm = this;
                vm.loading = Loading.service({
                    lock: true,
                    text: '正在检索中···',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                
                // 调用真实接口进行检索
                const params = {
                    pageSize: vm.pageSize,
                    pageNum: vm.currentPage,
                    cisbn: vm.form.cisbn
                };
                
                collectionretrieval(params).then(res => {
                    vm.loading.close();
                    if (res.code == '200') {
                        // 假设接口返回的数据结构为 {list: [...], total: 100}
                        vm.searchResults = res.data.entities || [];
                        vm.totalItems = res.data.totalCount || 0;
                        vm.searchCompleted = true;
                    } else {
                        vm.$message({
                            message: res.msg || '检索失败，请稍后重试',
                            type: 'error'
                        });
                    }
                }).catch(error => {
                    vm.loading.close();
                    vm.$message({
                        message: '检索失败，请稍后重试',
                        type: 'error'
                    });
                    console.error('检索失败:', error);
                });
            },
            // 返回检索页面
            backToSearch() {
                this.searchCompleted = false;
            },
            // 查看详情
            // viewDetail(row) {
            //     this.$message({
            //         message: `您正在查看《${row.title}》的详细信息`,
            //         type: 'info'
            //     });
            //     // 这里可以添加查看详情的逻辑，如打开详情页或弹出详情对话框
            // },
            // 获取资源类型对应的标签类型
            getTagType(type) {
                const typeMap = {
                    '图书': '',
                    '期刊': 'success',
                    '电子资源': 'info'
                };
                return typeMap[type] || '';
            },
            // 分页处理
            handleSizeChange(val) {
                this.pageSize = val;
                if (this.searchCompleted) {
                    this.fetchPageData();
                }
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                if (this.searchCompleted) {
                    this.fetchPageData();
                }
            },
            // 获取分页数据
            fetchPageData() {
                let vm = this;
                vm.tableLoading = true;
                
                const params = {
                    pageSize: vm.pageSize,
                    pageNum: vm.currentPage,
                    cisbn: vm.form.cisbn
                };
                
                collectionretrieval(params).then(res => {
                    vm.tableLoading = false;
                    if (res.code == '200') {
                        vm.searchResults = res.data.entities || [];
                        vm.totalItems = res.data.total || 0;
                    } else {
                        vm.$message({
                            message: res.msg || '获取数据失败',
                            type: 'error'
                        });
                    }
                }).catch(error => {
                    vm.tableLoading = false;
                    vm.$message({
                        message: '获取数据失败',
                        type: 'error'
                    });
                    console.error('获取数据失败:', error);
                });
            }
        },
    };
</script>

<style lang='scss'>
    // @import "src/style/common";

    .collect_box {
        margin: 20px auto 0;
        padding: 20px 14px;
        background: #fff;
        border-radius: 4px;
        width: 1200px;
        min-height: 700px;

        .form-btn {
            display: inline-block;
            width: 78px;
            height: 28px;
            line-height: 28px;
            text-align: center;
            color: #fff;
            font-size: 12px;
            border-radius: 2px;
            -moz-border-radius: 2px;
            -webkit-border-radius: 2px;
            cursor: pointer;
        }

        .form_left {
            margin-top: 60px;

            .m_info {
                display: block;
                line-height: 20px;
                color: #999;
                font-size: 12px;
            }

            .el-form-item__label {
                line-height: 25px;
                color: #333;
                font-size: 12px;
            }

            .el-form-item__content {
                line-height: 28px;

                .el-form-item__label {
                    color: #333;
                    font-size: 12px;
                }

                .el-input {
                    font-size: 12px;

                    .el-input__inner {
                        border-color: #b6d5f1;
                        line-height: 28px;
                        height: 28px;
                    }

                    .el-input__icon {
                        line-height: 28px;
                    }
                }

                .el-select {
                    width: 100%;
                }
            }
        }

        .button_box {
            text-align: center;
            margin-top: 100px;
        }

        .tips_s {
            margin-top: 40px;
            width: 316px;
            height: 260px;
            font-size: 12px;
            background: #fefde1;
            color: #39382a;
            float: left;
            padding: 30px 40px 20px;
            background-size: 352px 295px;
            position: relative;

            p {
                line-height: 1.8;
            }

            .tit {
                i {
                    display: inline-block;
                    width: 23px;
                    height: 23px;
                    background: url("../../assets/images/icon2.png") no-repeat;
                    background-position: -89px -53px;
                    position: absolute;
                    left: 8px;
                    top: 28px;
                }

                span {
                    display: inline-block;
                    border: 1px solid #ff9d00;
                    height: 18px;
                    padding: 0px 5px 0px 10px;
                    line-height: 18px;
                    border-radius: 5px;
                    margin-left: -15px;
                }
            }
        }
        
        .search-result {
            padding: 20px;
            
            .result-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 20px;
                
                h3 {
                    font-size: 16px;
                    color: #333;
                }
            }
            
            .available {
                color: #67C23A;
            }
            
            .unavailable {
                color: #F56C6C;
            }
            
            .pagination-container {
                margin-top: 20px;
                text-align: right;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/importENewspaper/index.vue